import React from 'react';

// Champion Banner SVG Components
export const ChampionBannerLeft = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18" fill="none">
        <path d="M1.00073 17.43H30.4807C31.0307 17.43 31.4807 16.98 31.4807 16.43V1.60999C31.4807 1.05999 31.0307 0.609985 30.4807 0.609985H1.00073C0.270734 0.609985 -0.209266 1.35999 0.0907344 2.01999L3.07073 8.59999C3.19073 8.85999 3.19073 9.15999 3.07073 9.41999L0.0907344 16.02C-0.209266 16.68 0.270734 17.43 1.00073 17.43Z" fill="#CD8900" />
    </svg>
);

export const ChampionBannerRight = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="18" viewBox="0 0 32 18" fill="none">
        <path d="M30.6402 17.43H1.16016C0.610156 17.43 0.160156 16.98 0.160156 16.43V1.60999C0.160156 1.05999 0.610156 0.609985 1.16016 0.609985H30.6402C31.3702 0.609985 31.8502 1.35999 31.5502 2.01999L28.5702 8.59999C28.4502 8.85999 28.4502 9.15999 28.5702 9.41999L31.5502 16C31.8502 16.66 31.3702 17.41 30.6402 17.41V17.43Z" fill="#CD8900" />
    </svg>
);

export const ChampionBannerTop = ({ ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="85" height="25" viewBox="0 0 85 25" fill="none">
        <path d="M2.32031 0.5H82.3203C83.1525 0.5 83.8203 1.17451 83.8203 2V16.9902C83.8203 17.3847 83.6651 17.7587 83.377 18.0469L77.3623 24.0615C77.0888 24.3424 76.7088 24.4999 76.3105 24.5H8.33008C7.93561 24.4999 7.56164 24.3448 7.27344 24.0566L1.25879 18.042L1.15918 17.9346C0.94083 17.6732 0.820367 17.3387 0.820312 16.9902V2C0.820312 1.17614 1.49645 0.5 2.32031 0.5Z" fill="url(#paint0_linear_308_4076)" stroke="url(#paint1_linear_308_4076)" />
        <defs>
            <linearGradient id="paint0_linear_308_4076" x1="0.320312" y1="12.5" x2="84.3203" y2="12.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#D89000" />
                <stop offset="0.490385" stopColor="#FFC800" />
                <stop offset="1" stopColor="#D89000" />
            </linearGradient>
            <linearGradient id="paint1_linear_308_4076" x1="0.320312" y1="12.5" x2="84.3203" y2="12.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#EFA610" />
                <stop offset="0.456731" stopColor="#FDFF77" />
                <stop offset="1" stopColor="#EAC360" />
            </linearGradient>
        </defs>
    </svg>
);

export default {
    ChampionBannerLeft,
    ChampionBannerRight,
    ChampionBannerTop
};
